export default __webpack_public_path__ + "static/media/12_1_sub_overview.59046692.png";